import React from 'react'
import { useState,useEffect } from 'react'
import './ToggleSwitch.css'

const ToggleSwitch = () => {

const [isDarkMode, setIsDarkMode] = useState(false)

const toggleColorMode = () => {
  setIsDarkMode(!isDarkMode);
};

useEffect(() => {
  const body = document.body;
  const header = document.querySelector('header');
  const h1 = document.querySelector("h1");
  const p = document.querySelector("p");
  const options = document.getElementById("options_container");
  const bgcv = document.getElementById('background_fotocv');
  const cvbg = document.getElementById('bgcv');
  const bordercv = document.getElementById("cv");
  const href = document.getElementById("icon_a");
  const href2 = document.getElementById("icon_b");
  const href3 = document.getElementById("icon_c");
  const href4 = document.getElementById("icon_d");
  const l1 = document.getElementById('l1');
  const l2 = document.getElementById('l2');
  const l3 = document.getElementById('l3');
  if (isDarkMode) {
    body.classList.add('dark-mode');
    body.classList.remove('light-mode');
    header.classList.add('dark-mode');
      header.classList.remove('light-mode');
      h1.classList.add('dark-mode');
      h1.classList.remove('light-mode');
      p.classList.add('dark-mode');
      p.classList.remove('light-mode');
      options.style.backgroundColor = "black"
      bgcv.style.backgroundColor = '#1b1b1b'
      cvbg.style.backgroundColor = '#1b1b1b'
      bordercv.style.borderColor = "#1b1b1b"
      bordercv.style.color = "white"
      href.style.color = "#1b1b1b";
      href2.style.color = "#1b1b1b";
      href3.style.color = "#1b1b1b";
      href4.style.color = "#1b1b1b";
      l1.style.backgroundColor = "white"
      l2.style.backgroundColor = "white"
      l3.style.backgroundColor = "white"
  } else {
    body.classList.add('light-mode');
    body.classList.remove('dark-mode');
    header.classList.add('light-mode');
      header.classList.remove('dark-mode');
      h1.classList.add('light-mode');
      h1.classList.remove('dark-mode');
      p.classList.add('light-mode');
      p.classList.remove('dark-mode');
      options.style.backgroundColor = "white"
      bgcv.style.backgroundColor = "black"
      cvbg.style.backgroundColor = 'black'
      bordercv.style.borderColor = "black"
      bordercv.style.color = "black"
      href.style.color = "black";
      href2.style.color = "black";
      href3.style.color = "black";
      href4.style.color = "black";
      l1.style.backgroundColor = "black"
      l2.style.backgroundColor = "black"
      l3.style.backgroundColor = "black"
  }
}, [isDarkMode]);

  return (
    <div>
        <label class="switch">
        <input type="checkbox" onChange={toggleColorMode} checked={isDarkMode}></input>
        <span class="slider"></span>
        </label>
    </div>
  )
}

export default ToggleSwitch